import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StudentDebtNotificationType, StudentDebtType } from '../../../types/Finance';

const initialState:StudentDebtNotificationType = {
  idStudentDebt: '',
  isViewed: false,
  message: '',
  status: true
}

const studentDebtNotificationSlice = createSlice({
  name: "studentDebtNotification",
  initialState,
  reducers: {
    setStudentDebtNotificationData:(state, action:PayloadAction<StudentDebtNotificationType>)=>({...state, ...action.payload}), 
    resetStudentDebtNotificationData :()=>({...initialState})
  }
});

export const {setStudentDebtNotificationData,resetStudentDebtNotificationData} = studentDebtNotificationSlice.actions

export default studentDebtNotificationSlice.reducer